var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 45 C 90 20.147 69.853 0 45 0 C 20.147 0 0 20.147 0 45 s 20.147 45 45 45 C 69.853 90 90 69.853 90 45 z M 37.95 62.826 L 24.689 47.63 c -0.058 -0.066 -0.099 -0.141 -0.152 -0.211 c -0.072 -0.094 -0.144 -0.186 -0.207 -0.286 c -0.075 -0.118 -0.137 -0.241 -0.198 -0.365 c -0.049 -0.099 -0.101 -0.195 -0.142 -0.298 c -0.057 -0.144 -0.097 -0.292 -0.137 -0.44 c -0.025 -0.093 -0.057 -0.181 -0.075 -0.277 c -0.048 -0.249 -0.076 -0.501 -0.076 -0.754 c 0 -0.253 0.028 -0.505 0.076 -0.754 c 0.018 -0.095 0.05 -0.183 0.075 -0.276 c 0.04 -0.149 0.08 -0.296 0.137 -0.441 c 0.041 -0.103 0.093 -0.199 0.142 -0.298 c 0.061 -0.124 0.123 -0.246 0.198 -0.364 c 0.064 -0.1 0.135 -0.193 0.207 -0.287 c 0.053 -0.069 0.094 -0.144 0.152 -0.21 L 37.95 27.174 c 1.452 -1.665 3.979 -1.836 5.644 -0.384 c 1.665 1.453 1.836 3.979 0.384 5.644 L 36.502 41 h 25.794 c 2.209 0 4 1.791 4 4 s -1.791 4 -4 4 H 36.502 l 7.475 8.566 c 1.453 1.664 1.28 4.19 -0.384 5.644 S 39.402 64.491 37.95 62.826 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconCircle);
export default __webpack_public_path__ + "static/media/back_icon_circle.8c3be7b3349316f6d09404aee5fd3e0a.svg";
export { ForwardRef as ReactComponent };